
import { addCart } from '@/services/http';
import { readCookie } from '@/tools/tools';
import { Action, State, Mutation } from 'vuex-class';
import {
  Component, Vue, Prop, Watch
} from 'vue-property-decorator';

@Component({
  name: 'SKU'
})
export default class extends Vue {
  dialogVisible: any = false

  dataList: any = []

  priceList: any = []

  selectprice: any[] = []

  quantity: any = 1

  productInfo: any = {

  }

  imgFirst = ''

  objData: any = {}

  selectedSku: any = {
    id: 0,
    natureValue: ''
  }// 当前选中的SKU

  @Action('card/setCardNum') setCardNum!: Function

  @Action('white/setWhiteStauts') setWhiteStauts!: Function

  selectSku(sku: any) {
    this.selectedSku = sku;

    // 确保类型一致，都转为字符串比较
    const currentId = String(sku.id);

    this.selectprice = this.objData.pricelist.filter((item: any) => String(item.natureIds) === currentId);
    if (this.selectprice.length > 0 && this.selectprice[0].mallImage) {
      this.imgFirst = this.selectprice[0].mallImage.cdnFilePathH5;
      this.productInfo = this.selectprice[0];
    } else {
      this.imgFirst = this.objData.FilePathPcimg;
    }
  }

  handSku(item: any) {
    this.quantity = 1;
    this.objData = item;
    this.selectedSku.id = item.selectarr[0].id;
    this.selectedSku.natureValue = item.selectarr[0].natureValue;
    this.productInfo = item.pricelist[0];
    this.imgFirst = item.FilePathPcimg;
    this.selectprice = this.objData.pricelist.filter((item: any) => String(this.selectedSku.id) === item.natureIds);
    this.dialogVisible = true;
  }

  handClick() {
    const anchor = readCookie('anchor');
    addCart({
      productPriceId: this.selectprice[0]?.id,
      num: this.quantity,
      equip: anchor ? anchor.equip : '',
      version: anchor ? anchor.version : '',
      companyId: 1
    }).then((res: any) => {
      if (res.data.code == 100) this.$message.success('加入购物车成功');
      this.dialogVisible = false;
      this.setCardNum();
      this.setWhiteStauts();
    });
  }
}

